module.exports = __webpack_public_path__ + "static/img/bg.a6e1966.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.jpg
// module id = dZ/S
// module chunks = 1